import { PaymentMethodType } from "ts/api/paymentMethod";

type PaymentTypeMap = {
  [k in PaymentMethodType]: { label: string };
};
const paymentTypesMap: PaymentTypeMap = {
  [PaymentMethodType.notSelected]: { label: "Not Selected" },
  [PaymentMethodType.cardPayment]: { label: "Card" },
  [PaymentMethodType.bankTransfer]: { label: "Bank Transfer" },
  [PaymentMethodType.idealPayment]: { label: "Card (iDEAL)" },
};

export default paymentTypesMap;
